import React from 'react';
import { Form } from 'react-bootstrap';
import ImageUploader from '../ImageUploader';

function PosterWidgetEditor({ item, websiteId, onChange }) {
  const set = (patch) => onChange({ ...item, ...patch });

  return (
    <div>
      <div className="form-row-horizontal mb-2">
        <Form.Label>Background type</Form.Label>
        <div className="bg-type-toggle">
          <button
            type="button"
            className={`bg-type-btn${item.backgroundType === 'image' ? ' bg-type-btn--active' : ''}`}
            onClick={() => set({ backgroundType: 'image', background: '', backgroundVertical: '' })}
          >
            Image
          </button>
          <button
            type="button"
            className={`bg-type-btn${item.backgroundType === 'youtube-video' ? ' bg-type-btn--active' : ''}`}
            onClick={() => set({ backgroundType: 'youtube-video', background: '', backgroundVertical: '' })}
          >
            Video
          </button>
        </div>
      </div>

      <div className="form-row-horizontal mb-2">
        <Form.Label>Background horizontal {item.backgroundType === 'youtube-video' ? 'URL' : ''}</Form.Label>
        {item.backgroundType === 'image' ? (
          <>
            <ImageUploader websiteId={websiteId} onUploaded={(resp) => set({ background: resp.url })} />
            {item.background && (
              <img src={item.background} alt="Background horizontal" className="poster-bg-preview mt-2" />
            )}
          </>
        ) : (
          <Form.Control
            type="url"
            value={item.background || ''}
            onChange={(e) => set({ background: e.target.value })}
            placeholder="https://youtu.be/..."
          />
        )}
      </div>

      <div className="form-row-horizontal mb-2">
        <Form.Label>Background vertical {item.backgroundType === 'youtube-video' ? 'URL' : ''}</Form.Label>
        {item.backgroundType === 'image' ? (
          <>
            <ImageUploader websiteId={websiteId} onUploaded={(resp) => set({ backgroundVertical: resp.url })} />
            {item.backgroundVertical && (
              <img src={item.backgroundVertical} alt="Background vertical" className="poster-bg-preview mt-2" />
            )}
          </>
        ) : (
          <Form.Control
            type="url"
            value={item.backgroundVertical || ''}
            onChange={(e) => set({ backgroundVertical: e.target.value })}
            placeholder="https://youtu.be/..."
          />
        )}
      </div>

      <div className="form-row-horizontal mb-2">
        <Form.Label>Heading</Form.Label>
        <Form.Control
          type="text"
          value={item.heading || ''}
          onChange={(e) => set({ heading: e.target.value })}
          placeholder="Main heading (optional)"
        />
      </div>

      <div className="form-row-horizontal mb-2">
        <Form.Label>Subheading</Form.Label>
        <Form.Control
          type="text"
          value={item.subheading || ''}
          onChange={(e) => set({ subheading: e.target.value })}
          placeholder="Optional subheading"
        />
      </div>

      <div className="form-row-horizontal mb-2">
        <Form.Label>Overlay text colour</Form.Label>
        <Form.Control
          type="color"
          value={item.overlayColor || '#ffffff'}
          onChange={(e) => set({ overlayColor: e.target.value })}
          className="color-input-sm"
        />
      </div>

      <div className="form-row-horizontal mb-2">
        <Form.Label>Text shade colour</Form.Label>
        <Form.Control
          type="color"
          value={item.textShadeColor || '#000000'}
          onChange={(e) => set({ textShadeColor: e.target.value })}
          className="color-input-sm"
        />
      </div>

      <div className="form-row-horizontal mb-3">
        <Form.Label>Preview</Form.Label>
        <div
          className="poster-mini-preview"
          style={item.background && item.backgroundType === 'image' ? { backgroundImage: `url(${item.background})` } : {}}
        >
          <div className="poster-mini-overlay" style={{ background: `${item.textShadeColor || '#000000'}66` }}>
            {item.heading || item.subheading ? (
              <>
                {item.heading && <div className="poster-mini-heading" style={{ color: item.overlayColor || '#ffffff' }}>{item.heading}</div>}
                {item.subheading && <div className="poster-mini-subheading" style={{ color: item.overlayColor || '#ffffff' }}>{item.subheading}</div>}
              </>
            ) : (
              <div className="poster-mini-placeholder" style={{ color: item.overlayColor || '#ffffff' }}>Enter a heading to preview</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PosterWidgetEditor;
